(() => {
  if (customElements.get('ruv-home-preview')) return;
  customElements.define('ruv-home-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const data = this.querySelector('[data-ruv-variants]');
      if (!data) return;
      try { this.variants = JSON.parse(data.textContent); } catch (_) { return; }
      this.swatches = Array.from(this.querySelectorAll('[data-ruv-variant]'));
      this.swatches.forEach((swatch, index) => {
        swatch.addEventListener('click', () => this.selectVariant(swatch.dataset.ruvVariant));
        swatch.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.swatches.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + this.swatches.length) % this.swatches.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.swatches.length - 1;
          else return;
          event.preventDefault();
          this.swatches[next].focus();
          this.selectVariant(this.swatches[next].dataset.ruvVariant);
        });
      });
    }
    selectVariant(id) {
      const variant = this.variants.find(item => String(item.id) === String(id));
      if (!variant) return;
      this.swatches.forEach(swatch => {
        const checked = swatch.dataset.ruvVariant === String(id);
        swatch.setAttribute('aria-checked', String(checked));
        swatch.tabIndex = checked ? 0 : -1;
      });
      const image = this.querySelector('[data-ruv-product-image]');
      if (image && variant.image) { image.src = variant.image; image.alt = variant.alt || `RUVALINO Classic backpack in ${variant.label}`; }
      this.querySelector('[data-ruv-price]').textContent = variant.price;
      this.querySelector('[data-ruv-color]').textContent = variant.label;
      this.querySelector('[data-ruv-shop]').href = variant.url;
      this.querySelector('[data-ruv-shop-label]').textContent = variant.available ? `Shop ${variant.label}` : 'Sold out — view details';
      this.querySelector('[data-ruv-availability]').textContent = variant.available ? `${variant.label} selected.` : `${variant.label} is currently sold out.`;
    }
  });
})();
